import {translation} from "@2d-front-monorepo/core";
import {MaterialIcon} from "@2d-front-monorepo/design-library";
import {IAttachments} from "@2d-front-monorepo/permits-business";
import React, {JSX, memo} from "react";
import {createAttachmentHref} from "../helpers/createAttachmentHref";
import {attachmentTypeLabel} from "../helpers/enumNaming";
import {AttachmentResult} from "../types/AttachmentResult";
import {AttachmentStatusComponent} from "./AttachmentStatusComponent";

export type EntityDocumentationProps = {
	linkPrefix: string;
	entity: IAttachments;
}

type EntityAttachmentProps = {
	attachment: AttachmentResult;
	linkPrefix: string;
}

const EntityAttachment = memo(function EntityAttachment({attachment, linkPrefix}: EntityAttachmentProps): JSX.Element {
	const label = translation(attachmentTypeLabel(attachment.type));
	const href = createAttachmentHref(attachment, linkPrefix);

	return <li className="entity-documentation-entry">
		<a href={href} download target="_blank"><MaterialIcon icon="image"/>{label}</a>
		<AttachmentStatusComponent attachment={attachment} small={false}/>
	</li>;
});

const EntityDocumentation = memo(function EntityDocumentation(documentation: EntityDocumentationProps): JSX.Element {
	const {entity, linkPrefix} = documentation;
	const attachments = entity.attachments;
	if (attachments.length === 0) {
		return <></>;
	}

	return <ol className="entity-documentation-list">
		{attachments.map(((attachment, i) =>
			<EntityAttachment key={i} attachment={attachment} linkPrefix={linkPrefix}/>)
		)}
	</ol>;
}) as React.MemoExoticComponent<(props: EntityDocumentationProps) => JSX.Element>;

export default EntityDocumentation;
